// extracted by mini-css-extract-plugin
export default {"indicatesRequiredField":"IndicatesRequiredField_indicatesRequiredField__N892S"};